import { Text } from '@chakra-ui/react';

export default function Callout({ text }: { text: string }) {
  return (
    <Text
      maxW={{ base: '90%', md: '85%', lg: '46.25rem' }}
      pl="2rem"
      m={{ base: '3.125rem 0', lg: '4rem 0' }}
      fontWeight="600"
      color="#415f7c"
      fontSize={{ base: '1.1rem', lg: '1.375rem' }}
      lineHeight={{ base: '1.5rem', lg: '1.875rem' }}
      position="relative"
      _before={{
        content: `""`,
        position: 'absolute',
        top: '0',
        bottom: '0',
        margin: 'auto',
        left: '0',
        width: '0.1875rem',
        height: '90%',
        bgColor: '#415f7c',
      }}
    >
      {text}
    </Text>
  );
}
